import { render, staticRenderFns } from "./zws-steps.vue?vue&type=template&id=bbf4c8c4&scoped=true"
import script from "./zws-steps.vue?vue&type=script&lang=js"
export * from "./zws-steps.vue?vue&type=script&lang=js"
import style0 from "./zws-steps.vue?vue&type=style&index=0&id=bbf4c8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf4c8c4",
  null
  
)

export default component.exports